import React, { useState } from 'react';

import cx from 'classnames';
import { isNil } from 'ramda';
import CreatableSelect from 'react-select/creatable';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import selectStyles from 'components/shared/FormAdapters/FormDefault/ReactSelect/index.module.css';
import FormTitle from 'components/shared/Typography/FormTitle';

import styles from './index.module.css';

const COMPONENT_STATE = {
  IDLE: 'IDLE',
  SAVING_NEW: 'SAVING_NEW',
  UPDATING: 'UPDATING',
};
const componentState2ButtonLabelMap = {
  [COMPONENT_STATE.IDLE]: 'Save',
  [COMPONENT_STATE.SAVING_NEW]: 'Save As New',
  [COMPONENT_STATE.UPDATING]: 'Update Existing',
};
function SaveTemplateModal({ templateData, onCreate, onUpdate, close, options }) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let componentState;
  if (isNil(selectedValue)) {
    componentState = COMPONENT_STATE.IDLE;
    // eslint-disable-next-line no-underscore-dangle
  } else if (selectedValue.__isNew__) {
    componentState = COMPONENT_STATE.SAVING_NEW;
  } else {
    componentState = COMPONENT_STATE.UPDATING;
  }

  const handleCreate = async (name, data) => {
    setIsLoading(true);
    try {
      await onCreate({ name, data });
    } finally {
      setIsLoading(false);
      close();
    }
  };

  const handleUpdate = async (templateId, name, data) => {
    setIsLoading(true);
    try {
      await onUpdate(templateId, { name, data });
    } finally {
      setIsLoading(false);
      close();
    }
  };

  const componentState2SubmitHandlerMap = {
    [COMPONENT_STATE.IDLE]: () => undefined,
    [COMPONENT_STATE.SAVING_NEW]: (selectedValue) => () => handleCreate(selectedValue.label, templateData),
    [COMPONENT_STATE.UPDATING]: (selectedValue) => () =>
      handleUpdate(selectedValue.value, selectedValue.label, templateData),
  };

  return (
    <div>
      <FormTitle>Save Cost as Template</FormTitle>
      <LabelWrapper>
        <Label noTransform>What is the template name?</Label>
      </LabelWrapper>
      <div className={cx(selectStyles.reactSelectContainer, styles.createTemplateSelect)}>
        <CreatableSelect
          value={selectedValue}
          onChange={setSelectedValue}
          options={options}
          formatCreateLabel={(label) => `Create new template: "${label}"`}
          classNamePrefix="react-select"
          placeholder="Enter Template Name..."
        />
      </div>

      <FormActions isRight>
        <Button
          disabled={isLoading || componentState === COMPONENT_STATE.IDLE}
          htmlType="button"
          onClick={componentState2SubmitHandlerMap[componentState](selectedValue)}
        >
          {componentState2ButtonLabelMap[componentState]}
        </Button>
      </FormActions>
    </div>
  );
}

export default SaveTemplateModal;
